import React from "react";
import {
  Box,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useQuiz } from "../Context/QuizContext";

const SelectField = ({ label, option }) => {
  const { quizData, setCategory, setDifficulty, setType } = useQuiz();

  const handleChange = (e) => {
    const value = e.target.value;
    if (label === "Category") {
      setCategory(value);
    } else if (label === "Difficulty") {
      setDifficulty(value);
    } else if (label === "Type") {
      setType(value);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={3} width="100%">
        <FormControl fullWidth size="small">
          <InputLabel>{label}</InputLabel>
          <Select
            value={quizData[label.toLowerCase()]}
            label={label}
            onChange={handleChange}
          >
            {option &&
              option.map(({ id, name }) => {
                return (
                  <MenuItem value={id} key={id}>
                    {name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </Box>
    </Container>
  );
};

export default SelectField;
